import React from 'react';

// Loose red-pen strokes, stretched over the struck-out run (the SVG is not
// aspect-locked) and alternated so two corrections never look stamped.
const STRIKES = [
  'M2 18 C 30 15, 62 13, 98 7',
  'M2 14 C 32 15, 64 9, 98 8'
];

// What the child wrote, marked up like a teacher's pen on a worksheet: wrong
// letters crossed out with the right ones written above, a caret where letters
// are missing. `segments` come from diffSpelling.
export default function SpellingMarkup({ segments }) {
  const wrote = segments.map(s => (s.type === 'same' ? s.text : s.wrong)).join('');
  const length = segments.reduce((n, s) => n + (s.type === 'same' ? s.text.length : Math.max(s.wrong.length, s.right.length)), 0);
  let marks = 0;
  return <div className="spelling-markup" role="img" aria-label={`You wrote ${wrote}`}
    style={{ fontSize: `${Math.max(18, Math.min(46, 330 / length))}px` }}>
    {segments.map((segment, i) => {
      if (segment.type === 'same') return <span className="mark-same" key={i}>{segment.text}</span>;
      const n = marks;
      marks += 1;
      return <span className="mark-change" key={i} style={{ '--n': Math.min(n, 3) }}>
        {segment.right && <span className={`mark-note ${n % 2 ? 'tilt-up' : ''}`} aria-hidden="true">{segment.right}</span>}
        {segment.wrong
          ? <span className="mark-wrong">{segment.wrong}
            <svg className="mark-strike" viewBox="0 0 100 24" preserveAspectRatio="none" aria-hidden="true"><path d={STRIKES[n % 2]}/></svg></span>
          : <svg className="mark-caret" viewBox="0 0 20 20" aria-hidden="true"><path d="M3 17 L10 4 L17 17"/></svg>}
      </span>;
    })}
  </div>;
}
